<template>
  <div class="overflow-x-hidden">
    <!-- <el-button type="" @click="test">test</el-button> -->
    <CategoryTitle title="特种设备预警" />
    <div class="max-h-159px overflow-x-hidden">
      <DiyStatistic
        v-for="(it, index) in specialDeviceList"
        :key="index"
        :statisticData="it"
        textFontSize="!text-14px"
        class="cursor-pointer"
        @click.native="specialDeviceInfo(it)"
      ></DiyStatistic>
    </div>
    <CategoryTitle title="检验统计" />
    <div class="flex flex-wrap justify-between">
      <DiyStatistic
        backgroundType="metalShortBackground"
        :statisticData="it"
        v-for="(it, index) in statisticList"
        :key="index"
        class="w-49/100"
      ></DiyStatistic>
    </div>
    <CategoryTitle title="检验单位告警" />
    <div class="flex flex-wrap justify-between">
      <DiyStatistic
        :backgroundType="it.type ? 'metalLongBackground' : 'metalShortBackground'"
        :statisticData="it"
        v-for="(it, index) in inspectionUnitList"
        :key="index"
        :class="it.type ? 'w-full' : 'w-49/100'"
      ></DiyStatistic>
    </div>
    <CategoryTitle title="施工单位告警" />
    <div>
      <DiyStatistic
        v-for="(it, index) in constructionUnitList"
        :key="index"
        :statisticData="it"
      ></DiyStatistic>
    </div>
  </div>
</template>

<script>
import { MetalCheckApi } from '@wiz-api/huizhou2'
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import DiyStatistic from './DiyStatistic'

const metalCheckApi = new MetalCheckApi()

export default {
  props: {
    cloudRender: {
      type: Object,
      default: () => {},
    },
  },
  components: { CategoryTitle, DiyStatistic },
  data() {
    return {
      statisticList: [
        {
          prop: 'entrustCount',
          img: 'statisticsEntrustCompletedNumber',
          value: '',
          label: '检验委托完成数量',
        },
        {
          prop: 'flawCount',
          img: 'statisticsOrdersCompletedNumber',
          value: '',
          label: '闭环单完成数量',
        },
        {
          prop: 'sampleInspectCount',
          img: 'statisticsSamplesCompletedNumber',
          value: '',
          label: '取样检验完成数量',
        },
        {
          prop: 'valveInspectCount',
          img: 'statisticsSafetyInspectionCommissionNumber',
          value: '',
          label: '安全阀检验委托数量',
        },
        {
          prop: 'reportCount',
          img: 'statisticsReportsIssuedNumber',
          value: '',
          label: '已出报告数量',
        },
        { prop: 'qualifiedJointRate', img: 'statisticsRate', value: '', label: '焊口一次合格率' },
      ],
      specialDeviceList: [
        { prop: 'onlineCount', img: 'specialtyOnline', value: '', label: '压力管道在线检验临期' },
        {
          prop: 'allCount',
          img: 'specialtyComprehensive',
          value: '',
          label: '压力管道全面检验临期',
        },
        {
          prop: 'containerYearCount',
          img: 'specialtyContainerYear',
          value: '',
          label: '压力容器年度检验临期',
        },
        {
          prop: 'containerRegularCount',
          img: 'specialtyContainersRegularBasis',
          value: '',
          label: '压力容器定期检验临期',
        },
        { prop: 'innerCount', img: 'specialtyInsideBoiler', value: '', label: '锅炉内检日临期' },
        {
          prop: 'suppportWarning',
          img: 'specialtySupportHanger',
          value: '',
          label: '支吊架全面检测日临期',
        },
        {
          prop: 'cylinderRegularCount',
          img: 'specialtyPressureCylinders',
          value: '',
          label: '压力气瓶定期检验临期',
        },
        {
          prop: 'simpleRegularCount',
          img: 'specialtySimplePressureVessels',
          value: '',
          label: '简单压力容器定期检验临期',
        },
        { prop: 'safeCount', img: 'specialtyReliefValve', value: '', label: '安全阀校验日临期' },
        { prop: 'outerCount', img: 'specialtyOutsideBoiler', value: '', label: '锅炉外检日临期' },
      ],
      inspectionUnitList: [
        {
          prop: 'inspectionPersonnelWarning',
          img: 'checkUnitPersonnel',
          value: '',
          label: '检验人员证书到期',
          type: '',
        },
        {
          prop: 'inspectionMaterialsWarning',
          img: 'checkUnitMaterial',
          value: '',
          label: '检验材料有效期到期',
          type: '',
        },
        {
          prop: 'inspectionEquipmentJdWarning',
          img: 'checkUnitInspectionTools',
          value: '',
          label: '检验工器具检定有效期到期',
          type: 'inspectionEquipmentJdWarning',
        },
        {
          prop: 'inspectionEquipmentHcWarning',
          img: 'checkUnitToolVerifiable',
          value: '',
          label: '检验工器具核查有效期到期',
          type: 'inspectionEquipmentHcWarning',
        },
      ],
      constructionUnitList: [
        {
          prop: 'weldPersonnelWarning',
          img: 'constructionCertificateExpires',
          value: '',
          label: '焊接人员证书到期',
          type: '',
        },
        {
          prop: 'weldMeasurementWarning',
          img: 'constructionMeasuringInstruments',
          value: '',
          label: '焊接计量仪器检定有效期到期',
          type: '',
        },
      ],
    }
  },
  methods: {
    async test() {},
    specialDeviceInfo(val) {
      this.$emit('openAlertList', val.prop)
    },
    async getInspectionUnitAlarm() {
      const [err, res] = await metalCheckApi.alarm()
      if (!err) {
        // 获取检验单位告警
        this.inspectionUnitList.forEach((it) => {
          it.value = res[it.prop]
        })
        // 获取施工单位告警
        this.constructionUnitList.forEach((it) => {
          it.value = res[it.prop]
        })
      }
    },
    // 获取特种设备预警
    async getSpecialEquipmentAlarm() {
      const [err, res] = await metalCheckApi.specialDeviceAlarm()
      if (!err) {
        this.specialDeviceList.forEach((it) => {
          it.value = res[it.prop]
        })
      }
    },
    // 获取检验统计
    async getTestStatistics() {
      const [err, res] = await metalCheckApi.statistic()
      if (!err) {
        this.statisticList.forEach((it) => {
          it.value = res[it.prop]
        })
      }
    },
  },
  created() {
    this.getInspectionUnitAlarm()
    this.getSpecialEquipmentAlarm()
    this.getTestStatistics()
  },
}
</script>

<style lang='scss' scoped>
</style>
